import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/ViewChildSkuMaster';


const ViewChildSkuMaster = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Child SKU MASTER - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewChildSkuMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewChildSkuMaster);
